import { AITrace } from "../models/aiTrace";
import axiosConfig from "./axiosConfig";

// Fetch the complete AI trace for one outreach turn. `subjectRef` is the outreach
// message id (a test run uses the synthetic ref the test response echoes); `runId`
// is the turn's `traceRunId`. Admin-only (inrange-org gated). Unlike the people-
// discovery trace endpoint, the BE returns the trace object directly (not wrapped).
const getOutreachTrace = async (
  authToken: string,
  subjectRef: string,
  runId: string
): Promise<AITrace | null> => {
  const { data } = await axiosConfig.get(`/leads/outreach-trace`, {
    params: { subjectRef, runId },
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return (data as AITrace) ?? null;
};

export default getOutreachTrace;
